import _tmpl from "./headerWrapper.html";
import { LightningElement, registerComponent as _registerComponent } from 'lwc';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
class HeaderWrapper extends LightningElement {
  get useUnifiedHeaderV2() {
    return getUserLanguage() !== JAPANESE_LANGUAGE_CODE;
  }
  /*LWC compiler v7.1.3*/
}
const __lwc_component_class_internal = _registerComponent(HeaderWrapper, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;